module.exports = __webpack_public_path__ + "img/tram.dfb5d080.svg";